<template>
  <div v-show="!isLegal">
    <v-row class="mb-5">
      <v-col cols="12">
        <h3 class="font-weight-bold">
          {{ translation(translationList.is_same_driver, 'Deținătorul masinii este acelasi cu șoferul mașinii?') }}
        </h3>
      </v-col>
    </v-row>
    <div
        class="border-0 px-0 py-0 d-inline-flex w-100"
    >
      <div
          class="px-5 py-2 cursor-pointer w-100 text-center border"
          @click="onTabChange(false)"
          :class="!isSameDriver ? 'bg-primary' : 'bg-primary-light'"
      >
        {{ translation(translationList.no, 'Nu') }}
      </div>
      <div
          class="px-5 py-2 cursor-pointer w-100 text-center border"
          @click="onTabChange(true)"
          :class="isSameDriver ? 'bg-primary' : 'bg-primary-light'"
      >
        {{ translation(translationList.yes, 'Da') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import {translation, useTranslationStore} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: [Boolean, null],
      default: false,
    },
    isLegal: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, { emit }) {
    const isSameDriver = ref(props.modelValue);
    const translationList = ref<TranslationList>({});

    const translationStore = useTranslationStore();

    const onTabChange = (newValue: boolean) => {
      isSameDriver.value = newValue;
      emit('update:modelValue', newValue);
    };

    watch(() => props.isLegal, (newValue) => {
      if (newValue) {
        isSameDriver.value = false; //it is mandatory to provide a driver if the owner is a legal entity
        emit('update:modelValue', isSameDriver.value);
      }
    });

    watch(() => props.modelValue, (newValue) => {
      isSameDriver.value = newValue;
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
    });

    return {
      isSameDriver,
      onTabChange,
      translationList,
      translation,
    };
  },
});
</script>

<style scoped>

</style>
